import { ServiceContext } from 'utilities/service.utils';

const ArcGISWorldGeocodingService = new ServiceContext(
  process.env.REACT_APP_ARCGIS_WORLD_GEOCODING_SERVICE_URL,
  {}
);

export default ArcGISWorldGeocodingService;
